import Swiper from 'swiper';

export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {

  /* Slider
  ---------------------------------------------------------------------------------------------------- */

    $('.image-slider').on('initSlider', function(){
  
      var el = $(this), 
          sliderEl = new Swiper($(el), {
              pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
              },
              autoplay: {
                delay: 5000,
              },
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
              slidesPerView: 1,
              spaceBetween: 0, 
              runCallbacksOnInit: true,
          });
      
      
      sliderEl.on('slideChangeStart', function(swiper){
        
        if(swiper.isBeginning) {
          $(el).addClass('is-beginning');
        } else {
          $(el).removeClass('is-beginning');
        }
        
        if(swiper.isEnd) {
          $(el).addClass('is-end');
        } else {
          $(el).removeClass('is-end');
        }
        
      });
      
  
    }); //.trigger('initSlider');
  
  
    setTimeout(function() {
      $('.image-slider').trigger('initSlider');
    }, 500);

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js